
/* injects from baggage-loader */

// Formas Cilindricas
import cilindro_type from '_images/yellow/cilindro/cilindro.png';
import copo from '_images/yellow/cilindro/copo.png';
import extintor from '_images/yellow/cilindro/extintor.png';
import lata from '_images/yellow/cilindro/lata.png';
import tambor from '_images/yellow/cilindro/tambor.png';

// Formas Coneidais
import cone_type from '_images/yellow/cone/cone.png';
import arvore from '_images/yellow/cone/arvore.png';
import chapeu from '_images/yellow/cone/chapeu.png';
import cone_de_transito from '_images/yellow/cone/cone-de-transito.png';
import sorvete from '_images/yellow/cone/sorvete.png';

// Formas Cuboides
import cubo_type from '_images/yellow/cubo/cubo.png';
import cubo_magico from '_images/yellow/cubo/cubo-magico.png';
import dado from '_images/yellow/cubo/dado.png';
import gelo from '_images/yellow/cubo/gelo.png';
import presente from '_images/yellow/cubo/presente.png';

// Formas Esféricas
import esfera_type from '_images/yellow/esfera/esfera.png';
import bola from '_images/yellow/esfera/bola.png';
import bola_de_sinuca from '_images/yellow/esfera/bola-de-sinuca.png';
import globo from '_images/yellow/esfera/globo.png';
import laranja from '_images/yellow/esfera/laranja.png';

// Formas Paralelepipedas
import paralelepipedo_type from '_images/yellow/paralelepipedo/paralelepipedo.png';
import caixa_de_bombons from '_images/yellow/paralelepipedo/caixa-de-bombons.png';
import caixa_de_sapatos from '_images/yellow/paralelepipedo/caixa-de-sapatos.png';
import predio from '_images/yellow/paralelepipedo/predio.png';
import tijolo from '_images/yellow/paralelepipedo/tijolo.png';

// Formas Piramidais
import piramide_type from '_images/yellow/piramide/piramide.png';
import piramide_do_egito from '_images/yellow/piramide/piramide-do-egito.png';
import piramide_magica from '_images/yellow/piramide/piramide-magica.png';
import relogio from '_images/yellow/piramide/relogio.png';
import vela from '_images/yellow/piramide/vela.png';


export const shapes = [
  { name: 'Cilindro', abstract: cilindro_type, realObjects: [copo, extintor, lata, tambor]  },
  { name: 'Cone', abstract: cone_type, realObjects: [arvore, chapeu, cone_de_transito, sorvete]  },
  { name: 'Cubo', abstract: cubo_type, realObjects: [cubo_magico, dado, gelo, presente]  },
  { name: 'Esfera', abstract: esfera_type, realObjects: [bola, bola_de_sinuca, globo, laranja]  },
  { name: 'Paralelepipedo', abstract: paralelepipedo_type, realObjects: [caixa_de_bombons, caixa_de_sapatos, predio, tijolo]  },
  { name: 'Piramide', abstract: piramide_type, realObjects: [piramide_do_egito, piramide_magica, relogio, vela]  }
]


// WEBPACK FOOTER //
// ./src/app/components/ui/memory-game/memory-game.const.js